import { render, staticRenderFns } from "./contentrule.vue?vue&type=template&id=707c1184&scoped=true"
import script from "./contentrule.vue?vue&type=script&lang=js"
export * from "./contentrule.vue?vue&type=script&lang=js"
import style0 from "./contentrule.vue?vue&type=style&index=0&id=707c1184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c1184",
  null
  
)

export default component.exports